export default "__VITE_ASSET__ri1Q3Uy1__"